import burger from "../assets/burger.png";
import cheesecake from "../assets/cheesecake.png";
import egg from "../assets/egg.png";
import ice from "../assets/icecream.png";
import moji from "../assets/mojita.png";
import pie from "../assets/pie.png";
import pizza from "../assets/pizza.png";
import wine from "../assets/wine.png";

export const MenuList = [
  {
    name: "Burger",
    image: burger,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Cheesecake",
    image: cheesecake,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Fried egg",
    image: egg,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Ice cream",
    image: ice,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Lemonade",
    image: moji,
    description: "made from gin vodka nad wine",
  },
  {
    name: "waffle",
    image: pie,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Farmhouse pizza",
    image: pizza,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Wine",
    image: wine,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Lemonade",
    image: moji,
    description: "made from gin vodka nad wine",
  },
  {
    name: "waffle",
    image: pie,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Farmhouse pizza",
    image: pizza,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Wine",
    image: wine,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Burger",
    image: burger,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Cheesecake",
    image: cheesecake,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Fried egg",
    image: egg,
    description: "made from gin vodka nad wine",
  },
  {
    name: "Ice cream",
    image: ice,
    description: "made from gin vodka nad wine",
  },
];
